import React from "react";

const GoogleDocsIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.54346 8.18164H11.4525V9.45437H4.54346V8.18164Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.54346 10.3633H9.63437V11.636H4.54346V10.3633Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.81622 4L12.0099 4.41455L13.8162 4L9.81622 0L9.2644 1.89636L9.81622 4Z",
  fill: "#1967D2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.54346 6H11.4525V7.27273H4.54346V6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.8163 4V0H3.27084C2.66811 0 2.17993 0.488182 2.17993 1.09091V14.9091C2.17993 15.5118 2.66811 16 3.27084 16H12.7254C13.3281 16 13.8163 15.5118 13.8163 14.9091V4H9.8163ZM9.45266 11.4545H4.72539V10.5455H9.45266V11.4545ZM11.2708 9.27273H4.72539V8.36364H11.2708V9.27273ZM11.2708 7.09091H4.72539V6.18182H11.2708V7.09091Z",
  fill: "#4285F4"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(GoogleDocsIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;